"use client";
import React, { FC } from "react";
import Overviewbox from "./services/Overviewbox";


const companyColor = "#0761a4";
// Bilder müssen im public folder ausgetauscht werden ->website\public\assets


// Example inline data (you could also import from 'productData.json')
const productData = [
    {
      title: "Innenputze",
      subtitle: "Wir verleihen Ihrem Rohbau den nächsten Schliff, vom Rohbau zum Wohntraum.",
      description: "Ob Neubau oder Sanierung, mit Putz drauf ist man gut drauf! Wir setzen Ihre Wünsche um und schaffen eine Atmosphäre, in der man sich rundum wohlfühlt.",
      imageSrc: "/assets/service-innenputz.webp",
      linkLabel: "Innenraumgestaltung",
      targetUrl: "services/innenputze",
      backgroundColor:companyColor,
      linkClickable:true,
    },
    
    {
      title: "Estrich & Bodentechnik",
      subtitle: "Fachgerechte Estrich- und Bodenlösungen für jeden Einsatzbereich.",
      description: "Professionell verlegt, nicht sichtbar und trotzdem tragend, stabil und belastbar sowie langlebig und den bauphysikalischen Anforderungen gewachsen.",
      // imageSrc: "/assets/service-estrich.jpg",
      imageSrc: "/assets/estrich1.jpg",
      linkLabel: "",
      targetUrl: "services/estrich-bodentechnik",
      backgroundColor:companyColor,
      linkClickable:true,
    },
    {
      title: "Außenputze",
      subtitle: "Der erste Eindruck zählt – auch bei Ihrer Fassade.",
      description: "Wir schützen und verschönern die Außenwände mit hochwertigen Materialien, damit Ihr Gebäude lange strahlt und vor Witterungseinflüssen geschützt ist.",
      // imageSrc: "/assets/service-außenputz.jpg",
      imageSrc: "/assets/service-außenputz2.png",
      linkLabel: "Fassadengestaltung",
      targetUrl: "services/aussenputze",
      backgroundColor:companyColor,
      linkClickable:true,
    },
    {
      title: "Wärmedämmverbundsysteme",
      subtitle: "Effiziente und nachhaltige Wärmedämmung für Alt- und Neubauten.",
      description: "WDVS sorgen für optimale Energieeffizienz, verbessern das Raumklima und Behaglichkeit Ihres Wohnraumes – ideal für Neubauten und Sanierungen.",
      imageSrc: "/assets/service-wdvs-waermedaemmverbundsysteme.webp",      
      linkLabel: "",
      targetUrl: "services/waermedaemmverbundsysteme",
      backgroundColor:companyColor,
      linkClickable:true
    },
    {
      title: "Gerüstbau",
      subtitle: "Sichere und flexible Gerüstlösungen für jedes Bauvorhaben.",
      description: "Sicherheit geht vor, maßgeschneiderte Gerüstlösungen für jeden Einsatz beim Neubau oder in der Sanierung.",
      imageSrc: "/assets/service-geruestbau.webp",
      linkLabel: "Gerüstbau",
      targetUrl: "services/geruestbau",
      linkClickable:true,
      backgroundColor:companyColor
    },
    {
      title: "Fensterbänke und Mauerabdeckungen",
      subtitle: "Schutz und Ästhetik für Fassaden und Mauern.",
      description: "Ein Systembestandteil jeder Fassade: Hochwertige Fensterbänke und Mauerabdeckungen bieten langlebigen Schutz vor Witterungseinflüssen und setzen stilvolle Akzente an Gebäuden.",
      imageSrc: "/assets/service-fensterbaenke-mauerabdeckungen.webp",
      linkLabel: "Fensterbänke und Mauerabdeckungen",
      targetUrl: "services/fensterbaenke-mauerabdeckungen",
      backgroundColor:companyColor,
      linkClickable:true,
    },
  ];

  // Helper function to chunk data into subarrays, each with `size` elements
function chunkArray<T>(array: T[], size: number): T[][] {
    const chunkedArr: T[][] = [];
    for (let i = 0; i < array.length; i += size) {
      chunkedArr.push(array.slice(i, i + size));
    }
    return chunkedArr;
  }

export const PresentationProducts: FC = () => {
 // If you fetch data from an API, you'd do something like:
  // const [products, setProducts] = useState([]);
  // useEffect(() => {
  //   fetch("/api/products")
  //     .then((res) => res.json())
  //     .then((data) => setProducts(data));
  // }, []);
  //
  // For now, we'll just use productData directly:
  const products = productData;

  // Create 2-column rows
  //const chunkedData = chunkArray(products, 2);

  const chunkSize = 2; // Ändere diese Zahl auf 2, 3 oder 4, je nach gewünschter Spaltenanzahl

  // Funktion zum Aufteilen des Arrays in Gruppen von chunkSize
  const chunkedData = chunkArray(products, chunkSize);
  
  // Berechne die Tailwind-Klasse für die Spaltenbreite dynamisch
  const getColumnWidth = (size: number) => `w-full md:w-1/${size}`;


   return (
    <div className="mx-auto max-w-screen-xl px-4 py-8">
      {chunkedData.map((row, rowIndex) => (
        <div className="flex flex-wrap -mx-2 mt-6" key={rowIndex}>
          {row.map((product, colIndex) => (
            <div className={`${getColumnWidth(chunkSize)} px-2 mb-4`} key={colIndex}>
              <Overviewbox
                title={product.title}
                subtitle={product.subtitle}
                backgroundColor={product.backgroundColor}
                description={product.description}
                imageSrc={product.imageSrc}
                linkLabel={product.linkLabel}
                targetUrl={product.targetUrl}
                linkClickable={product.linkClickable}
              />
            </div>
          ))}
        </div>
      ))}
    </div>
);

  return (
    <div className="mx-auto max-w-screen-xl px-4 py-8">
      {chunkedData.map((row, rowIndex) => (
        <div className="flex flex-wrap -mx-2 mt-6" key={rowIndex}>
          {row.map((product, colIndex) => (
            <div className="w-full md:w-1/2 px-2 mb-4" key={colIndex}>
              <Overviewbox
                title={product.title}
                subtitle={product.subtitle}
                backgroundColor = {product.backgroundColor}
                description={product.description}
                imageSrc={product.imageSrc}
                linkLabel={product.linkLabel}
                targetUrl={product.targetUrl}
                linkClickable={product.linkClickable}
              />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
